import { createSlice } from '@reduxjs/toolkit'

// ----------------------------------------------------------------------

export const initialState = {
  isLoading: false,
  error: null
}

const slice = createSlice({
  name: 'createError',
  initialState,
  reducers: {
    // START LOADING
    startErrorLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    setError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },
    // Set No Error
    setNoError(state) {
      state.isLoading = false
      state.error = null
    }
  }
})

// Reducer
export default slice.reducer

// ----------------------------------------------------------------------
export const { startErrorLoading, setError, setNoError } = slice.actions

export function getError(data: Response, status, dispatch) {
  dispatch(slice.actions.startErrorLoading())
  if (status.status !== 'OK') {
    dispatch(slice.actions.setError(data))
  } else {
    dispatch(slice.actions.setNoError())
  }
}
